<template>
    <div class="m-liveVideoExtend">

        <div v-show="inited">
            <div class="vcp-clarityswitcher switcher-line"
                 @mouseenter="lineMenuShow=true"
                 @mouseleave="lineMenuShow=false"
                 ref="lineSwitch">
                <a class="vcp-vertical-switcher-current switcher-line-current">
                    {{ [$t('live.mainLine'), $t('live.overseasLine')][$parent.line] }}
                </a>
                <div class="vcp-vertical-switcher-container" v-show="lineMenuShow">
                    <a @click="switchLine(0)"
                       class="vcp-vertical-switcher-item" :class="{'current':$parent.line===0}">{{$t('live.mainLine')}}</a>
                    <a @click="switchLine(1)"
                       class="vcp-vertical-switcher-item" :class="{'current':$parent.line===1}">{{$t('live.overseasLine')}}</a>
                </div>
            </div>
            <div class="vcp-refresh" :title="$t('live.reload')" ref="freshBtn" @click="resetPlayer">
                <i class="el-icon-refresh refresh-icon"></i>
            </div>
        </div>

        <!-- 全屏下的评论区 -->
        <div class="full-comment-wrap" ref="fullComment" v-if="fullscreen" @click.prevent.stop>
            <transition enter-active-class="animated fadeInRight"
                        leave-active-class="animated fadeOutRight">
                <div class="full-comment" v-show="fullCommentShow">
                    <ul class="full-comment-list">
                        <li class="full-comment-item" v-for="item in $parent.commentList" :key="item.id">
                            <span class="user" :class="{'self': item.userId===$parent.userInfo.userID}">
                                {{item.userName}}<i>{{item.time}}：</i>
                            </span>
                            <span class="content">{{item.content}}</span>
                        </li>
                    </ul>
                    <div class="full-chat-send">
                        <el-input
                            class="comment-textarea"
                            type="textarea"
                            :rows="2"
                            :placeholder="$t('tip.input')"
                            maxlength="200"
                            resize="none"
                            v-model="$parent.comment"
                            @keydown.enter.native.prevent="$parent.postComment"
                        >
                        </el-input>
                        <el-button @click="$parent.postComment" v-if="!$parent.limitSecond" class="btn-comment"
                                   type="primary" size="mini">
                            {{$t('live.send')}}
                        </el-button>
                        <el-button v-if="$parent.limitSecond" class="btn-comment" type="primary" size="mini"
                                   :disabled="true">
                            {{$parent.limitSecond}} {{$t('count.s')}}
                        </el-button>
                    </div>
                </div>
            </transition>
            <div class="btn-side" @click="fullCommentShow=!fullCommentShow">
                {{fullCommentShow?$t('live.foldComments'):$t('live.unfoldComments')}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                inited: false,
                lineMenuShow: false,
                fullscreen: false,
                fullCommentShow: true,
            }
        },
        mounted() {

        },
        methods: {
            init(msg) {
                if (msg.type === 'load') {
                    this.installBarPlugins()
                }

                if (msg.type === 'fullscreen') {
                    this.fullscreen = msg.detail.isFullscreen
                    if (this.fullscreen) {
                        this.installFullComment()
                    }
                }
            },

            installFullComment() {
                this.$nextTick(() => {
                    let $fullComment = this.$refs.fullComment

                    $('.vcp-player').append($fullComment)
                })
            },

            installBarPlugins() {
                this.inited = true
                if ($('.vcp-controls-panel .switcher-line').length) return

                let lineSwitch = this.$refs.lineSwitch
                let freshBtn = this.$refs.freshBtn

                $('.vcp-controls-panel').append(lineSwitch)
                $('.vcp-controls-panel').append(freshBtn)

            },
            switchLine(i) {
                this.lineMenuShow = false
                this.$emit('lineChanged', i)
            },
            resetPlayer() {
                this.$emit('resetPlayer')
            },
        },
    }
</script>

<style scoped lang="scss">
    @import '~@/style/const.scss';

    .full-comment-wrap {
        position: absolute;
        top: 60%;
        right: 0;
        margin-top: -170px;
        display: flex;
        z-index: 2000;

        .full-comment {
            width: 250px;
            background-color: rgba(0, 0, 0, .4);
            border-radius: 6px;
            @include scrollbar(rgba(0, 0, 0, .3));
        }

        .full-comment-list {
            height: 300px;
            padding: 10px;
            overflow: auto;
        }

        .full-comment-item {
            word-break: break-all;
            + .full-comment-item {
                margin: 6px 0;
            }
        }

        .user, .content {
            font-size: 12px;
            color: #f1f1f1;
        }

        .user {
            color: $color-theme;
            i {
                margin-left: 4px;
                font-style: normal;
                color: #999;
                font-size: 12px;
            }
        }

        .self {
            color: #ff5d23;
        }

        .full-chat-send {
            display: flex;

            .comment-textarea /deep/ textarea {
                font-family: "Helvetica Neue", Helvetica, "Microsoft YaHei";
                font-size: 12px;
                background-color: rgba(204, 204, 204, .4);
                color: #f1f1f1;
                border: none;
                border-radius: 4px 0 0 4px;
            }

            .btn-comment {
                border: none;
                border-left: 3px solid rgba(0, 0, 0, .4);
                background-color: rgba(204, 204, 204, .4);
                border-radius: 0 4px 4px 0;
            }
        }

        .btn-side {
            height: 76px;
            padding: 0 6px;
            text-align: center;
            writing-mode: vertical-lr;
            background-color: $color-theme;
            color: #fff;
            opacity: .3;
            cursor: pointer;

            &:hover {
                opacity: 3;
            }
        }
    }
</style>
<style lang="scss">
    .m-liveList {
        .vcp-controls-panel {
            font-size: 14px;
        }
        .vcp-vertical-switcher-item.current {
            color: #22B9FF;
        }
        .switcher-line {
            width: 75px;
            padding: 0 4px;
            .vcp-vertical-switcher-container {
                width:75px;
                display: block;
            }
            .vcp-vertical-switcher-item {
                padding:0 4px;
            }
        }
        .vcp-refresh {
            position: relative;
            float: right;
            width: 3em;
            height: 3em;
            line-height: 3em;
            text-align: center;
            z-index: 1001;
            cursor: pointer;
            .refresh-icon {
                font-size: 20px;
                color: #fff;
                vertical-align: sub;
            }
        }
    }
</style>
